import { render, staticRenderFns } from "./RecuperarPassword.vue?vue&type=template&id=5dc9aa28&"
import script from "./RecuperarPassword.vue?vue&type=script&lang=js&"
export * from "./RecuperarPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports